<template>
  <div
    class="fade-card bg-sky-900 p-6 rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1 transition"
  >
    <h3 class="text-xl font-semibold mb-2">
      {{ emoji }} {{ title }}
    </h3>
    <p class="text-gray-300">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    emoji: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script>
